// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@mdi/font/css/materialdesignicons.css'
import Buefy from "buefy"
import 'buefy/dist/buefy.css'
import store from "./store";
import Vuex from 'vuex'
import VueGtag from "vue-gtag";
import { AUTH_LOGOUT , AUTH_INITIALIZE} from "./store/actions/auth";

Vue.use(VueGtag, {
  config: { id: "UA-159881302-2" }
}, router);

Vue.use(Vuex)
Vue.use(Buefy)

Vue.config.productionTip = false

Vue.prototype.$api = {
  'REST_API': 'https://api.normsandratios.com',
//  'REST_API': 'http://localhost:8086',
  'APP_KEY': 'Dali-Atomicus-Picasso-Guernica-4151452-480BCE'
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created: function () {
    // `this` points to the vm instance
    console.log('Vue() App Created: ' )
    this.$store.dispatch(AUTH_INITIALIZE  ).then(() => {
      //  this.$router.push("/oops");
    
        //	this.$router.push('/dashboard')
        });
    // force auth_logout

  }
})



// WEBPACK FOOTER //
// ./src/main.js